export const SET_PRODUCT = 'SET_PRODUCT';
